document.addEventListener('DOMContentLoaded', function() {
    const anchors = document.querySelectorAll('a[href^="#"]');
    anchors.forEach(anchor => {
        anchor.addEventListener('click', function(e) {
            e.preventDefault();
            const targetId = this.getAttribute('href');
            const targetElement = document.querySelector(targetId);
            targetElement.scrollIntoView({ behavior: 'smooth' });
        });
    });
});
/* ─────────────────────────────────────────────────────────────────────────────
   Bildergalerie auf der Konfiguratorseite: Autoplay zähmen.

   Das Theme initialisiert die .slideshow per Slick (theme.initContentSlider)
   mit `autoplay: true` und hart gesetztem `pauseOnHover: false`. Beides wollen
   wir hier anders — ohne theme.js anzufassen, damit ein Theme-Update nichts
   überschreibt:

     1. Hover hält die Rotation an statt darüber hinwegzulaufen.
     2. Autoplay startet erst, wenn die Galerie im Viewport war. Vorher steht
        sie auf dem ERSTEN Bild — der Nutzer kommt also nie mitten in der
        Rotation an.

   Bewusst nur auf Seiten mit dem Konfigurator ([data-pc-root]). Die
   Startseiten-Slideshow bleibt unberührt.
   ───────────────────────────────────────────────────────────────────────────── */
(function () {
  if (!document.querySelector('[data-pc-root]')) return;

  // Auf Touch-Geräten gibt es kein echtes Hover. Ein emuliertes mouseenter
  // nach dem Antippen würde die Rotation sonst dauerhaft anhalten.
  var canHover = !window.matchMedia || window.matchMedia('(hover: hover)').matches;

  function enhance($, el) {
    var $el = $(el);
    if (!$el.hasClass('slick-initialized')) return false;
    if ($el.data('ssGalleryTamed')) return true;

    // Autoplay, das der Händler abgeschaltet hat, nicht heimlich einschalten.
    var wantsAutoplay = $el.data('autoplay') === true || $el.data('autoplay') === 'true';
    $el.data('ssGalleryTamed', true);
    if (!wantsAutoplay) return true;

    var hovering = false;
    var armed = false;      // Galerie war schon im Viewport?

    $el.slick('slickPause');
    $el.slick('slickGoTo', 0, true);

    function play() {
      if (armed && !hovering) $el.slick('slickPlay');
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            armed = true;
            io.disconnect();
            play();
            return;
          }
        }
      }, { threshold: 0.35 });
      io.observe(el);
    } else {
      armed = true;
      play();
    }

    if (canHover) {
      $el.on('mouseenter.ssGallery focusin.ssGallery', function () {
        hovering = true;
        $el.slick('slickPause');
      }).on('mouseleave.ssGallery focusout.ssGallery', function () {
        hovering = false;
        play();
      });
    }
    return true;
  }

  // theme.js initialisiert Slick nicht zu einem festen Zeitpunkt (Section-Load,
  // teils nach window.load). Deshalb beschränkt nachfassen statt zu raten.
  function run() {
    var $ = window.jQuery;
    if (!$) return false;
    var nodes = document.querySelectorAll('.slideshow');
    if (!nodes.length) return true;
    var done = true;
    for (var i = 0; i < nodes.length; i++) {
      if (!enhance($, nodes[i])) done = false;
    }
    return done;
  }

  var tries = 0;
  var timer = setInterval(function () {
    if (run() || ++tries > 60) clearInterval(timer);   // max. ~9 s
  }, 150);
  window.addEventListener('load', function () { setTimeout(run, 60); });
})();

/* ─────────────────────────────────────────────────────────────────────────────
   Judge.me-Karussell erst zeigen, wenn seine Karussell-CSS greift.
   Die App lädt carousels.css asynchron (media="nope!" → onload "all"); sind
   die Karten früher im DOM, stünden sie kurz ungestylt untereinander in voller
   Breite. Die Custom-CSS hält .jdgm-cards-carousel bis „ss-jdgm-ready“
   unsichtbar; Notausstieg nach 10 s.
   ───────────────────────────────────────────────────────────────────────────── */
(function () {
  if (!document.querySelector('.jdgm-cards-carousel')) return;
  var t0 = Date.now();
  function cssReady() {
    var links = document.querySelectorAll('link[href*="carousels.css"]');
    for (var i = 0; i < links.length; i++) {
      if (links[i].media === 'all' && links[i].sheet) return true;
    }
    return false;
  }
  (function check() {
    var pending = document.querySelectorAll('.jdgm-cards-carousel:not(.ss-jdgm-ready)');
    if (!pending.length) return;
    var timeout = Date.now() - t0 > 10000, css = cssReady();
    pending.forEach(function (w) {
      if (timeout || (css && !w.classList.contains('jdgm-hidden') && w.querySelector('.jdgm-card'))) {
        w.classList.add('ss-jdgm-ready');
      }
    });
    setTimeout(check, 100);
  })();
})();
